window.Vue = require('vue');

Vue.component('survey-managment', require('./surveyManagment.vue'));
Vue.component('question-row', require('./questionRow.vue'));



// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js